import React from 'react';

interface LogoOption {
  key: string;
  src: string;
}

interface LogoPickerProps {
  availableLogos?: LogoOption[];
  selections?: Record<string, string | null>;
  onAssign?: (slot: string, src: string) => void;
  showGraphicsSlots?: boolean;
  showPositionSlots?: boolean;
  objectivesCount?: number;
}

export default function LogoPicker({ availableLogos = [], selections = {}, onAssign, showGraphicsSlots = true, showPositionSlots = true, objectivesCount = 3 }: LogoPickerProps) {
  const [selectedLogo, setSelectedLogo] = React.useState<LogoOption | null>(null);

  return (
    <div>
      <div className="text-sm font-medium text-gray-700 mb-2">
        Objective Logos
      </div>
      <div className="grid grid-cols-4 gap-2 mb-2">
        {availableLogos.map((logo) => {
          return (
            <button
              key={logo.key}
              onClick={() => setSelectedLogo(logo)}
              className={`p-1 border rounded ${selectedLogo && selectedLogo.key === logo.key ? 'border-blue-500' : 'border-gray-200'}`}
              title={logo.key}
              style={{background: 'white', overflow: 'hidden', width: 48, height: 48, display: 'inline-flex', alignItems: 'center', justifyContent: 'center'}}
            >
              <img
                src={logo.src}
                alt={logo.key}
                style={{
                  width: 40,
                  height: 40,
                  objectFit: 'contain',
                  pointerEvents: 'none'
                }}
              />
            </button>
          );
        })}
      </div>

      {showPositionSlots && (
        <div className="flex justify-between items-center mb-2 w-full">
          {(() => {
            const count = Math.max(0, Math.min(3, Number.isFinite(objectivesCount) ? objectivesCount : 3));
            const buttons = count <= 1
              ? [{ slot: 'left', label: 'Center' }]
              : count === 2
                ? [
                    { slot: 'left', label: 'Left' },
                    { slot: 'center', label: 'Right' },
                  ]
                : [
                    { slot: 'left', label: 'Left' },
                    { slot: 'center', label: 'Center' },
                    { slot: 'right', label: 'Right' },
                  ];

            return buttons.map((btn, idx) => {
              const spacingClass = idx === 0 ? 'mr-1' : idx === buttons.length - 1 ? 'ml-1' : 'mx-1';
              return (
                <button
                  key={btn.slot}
                  onClick={() => selectedLogo && onAssign?.(btn.slot, selectedLogo.src)}
                  className={`flex-1 px-2 py-1 bg-gray-100 rounded text-sm ${spacingClass}`}
                >{btn.label}</button>
              );
            });
          })()}
        </div>
      )}
      
      {showGraphicsSlots && (
        <div className="flex gap-2 items-center mb-2 flex-wrap">
          <button
            onClick={() => selectedLogo && onAssign?.('graphics1', selectedLogo.src)}
            className="px-2 py-1 bg-blue-100 rounded text-sm"
          >Graphics Slot 1</button>
          <button
            onClick={() => selectedLogo && onAssign?.('graphics2', selectedLogo.src)}
            className="px-2 py-1 bg-blue-100 rounded text-sm"
          >Graphics Slot 2</button>
        </div>
      )}
    </div>
  );
}
